import React, { useEffect, useMemo } from 'react';
import { useMutation, useLazyQuery } from '@apollo/client';
import {
  getCurrentUserHook,
  getCustomViewValues,
  ColumnPersonalization
} from '@nile/components';
import { CustomViewModal } from '@nile/components';
import { ADD_VIEW } from '@nile/graphql/src/Mutation/views';
import { UPDATE_VIEW } from '@nile/graphql/src/Mutation/views';
import { GET_VIEW } from '@nile/graphql';

const CustomView = (props) => {
  const { onClose, module, actionType, onSuccess } = props;

  const columnPersonalization = ColumnPersonalization();

  const { moduleMetaClient } = getCustomViewValues(module);

  const user = getCurrentUserHook();

  const [
    getModuleView,
    { data: moduleViewData, loading, error }
  ] = useLazyQuery(GET_VIEW, {
    variables: {
      viewId: props.id,
      module: module
    },
    client: moduleMetaClient,
    fetchPolicy: 'network-only'
  });

  useEffect(() => {
    if (actionType == 'edit' && props.id) {
      getModuleView();
    }
  }, [props.id]);
  const [updateCustomView] = useMutation(UPDATE_VIEW, {
    client: moduleMetaClient
  });

  const viewData = useMemo(() => {
    if (moduleViewData) return moduleViewData?.getView;
  }, [moduleViewData]);

  const editView = async (editViewInput) => {
    const { input, columnPersonalizationInput } = editViewInput;

    const [res1, res2] = await Promise.all([
      updateCustomView({
        variables: {
          id: viewData?.id,
          input: input
        }
      }),
      saveColPersonalization(columnPersonalizationInput, viewData?.id)
    ]);
    // console.log('testing123', res1, res2);
    onSuccess({ module: module, viewData: res1?.data?.updateView });
  };

  const [addCustomView] = useMutation(ADD_VIEW, {
    client: moduleMetaClient
  });

  //Format column Data for save personalization api
  const saveColPersonalization = async (colData, viewId) => {
    const columnData = [];
    for (let i = 0; i < colData?.length; i++) {
      columnData.push(colData[i]?.name);
    }
    const personalizedColumn = {
      user: {
        firstName: user?.firstName,
        userId: user?.userId,
        email: user?.email,
        lastName: user?.lastName
      },
      category: `${module?.toLowerCase()}-columnPersonilsation`,
      name: viewId || 'columnPersonilsation',
      value: {
        columns: columnData
      }
    };

    const obj = {
      columnData,
      viewId,
      module,
      variables: {
        ...personalizedColumn,
        value: JSON.stringify(personalizedColumn.value)
      }
    };
    let response = await columnPersonalization?.saveColumnPersonalization(obj);
    return response;
  };

  // To add the new custom view & update personaliztion columns if there
  const addView = (addViewInput) => {
    const { input, columnPersonalizationInput } = addViewInput;
    return addCustomView({
      variables: { input }
    }).then((res) => {
      const id = res?.data?.addView?.id;
      saveColPersonalization(columnPersonalizationInput, id);
      onSuccess({ module: module, viewData: res?.data?.addView });
    });
  };

  const actions = {
    addAction: addView,
    editAction: editView,
    back: onClose
  };

  if (error) return null;

  return (
    <CustomViewModal
      isOpen
      viewId={props?.id}
      actionType={actionType}
      module={module}
      actions={actions}
      viewName={viewData?.name}
      isSharedChecked={viewData?.shared}
      viewCondition={viewData?.viewCondition}
      displayIcon={viewData?.displayIcon}
      isModuleViewLoading={loading}
    />
  );
};
export default CustomView;
